export default __webpack_public_path__ + "static/media/cold_background.a253ce54.png";